// v2: entries now carry attentionScore/rankTrend; v1 entries lack them and would
// leave cards unranked until they expire.
export const SMART_CARD_VDS_CACHE_STORAGE_KEY = 'smartCardVdsCache_v2';
export const SMART_CARD_VDS_CACHE_TTL_MS = 60 * 60 * 1000;

export const loadSmartCardVdsCache = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(SMART_CARD_VDS_CACHE_STORAGE_KEY));
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};

    const now = Date.now();
    return Object.keys(parsed).reduce((cache, key) => {
      const entry = parsed[key];
      const isValid = entry?.byScId &&
        typeof entry.byScId === 'object' &&
        !Array.isArray(entry.byScId) &&
        entry.timestamp &&
        (now - entry.timestamp) < SMART_CARD_VDS_CACHE_TTL_MS;
      if (isValid) cache[key] = entry;
      return cache;
    }, {});
  } catch (error) {
    console.error('Error loading smart card VDS cache from localStorage:', error);
    return {};
  }
};

export const saveSmartCardVdsCache = (cache) => {
  try {
    localStorage.setItem(SMART_CARD_VDS_CACHE_STORAGE_KEY, JSON.stringify(cache));
  } catch (error) {
    console.error('Error saving smart card VDS cache to localStorage:', error);
  }
};